import { getAuth } from '@firebase/auth'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import type { User } from 'firebase/auth'
import { onAuthStateChanged } from 'firebase/auth'
import { userQueryKeys } from '../hooks'
import { userStore } from '@/features/user/user.store'

let isSubscribed = false

export const useAuthSync = () => {
  const queryClient = useQueryClient()

  useEffect(() => {
    // Ensure only one subscription exists globally
    if (isSubscribed) return

    isSubscribed = true
    const auth = getAuth()

    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      // Directly update the cache without refetching
      queryClient.setQueryData<User | null>(
        userQueryKeys.authData.queryKey,
        firebaseUser,
      )

      if (firebaseUser) {
        userStore.userId = firebaseUser.uid
      }
    })

    return () => {
      isSubscribed = false
      unsubscribe()
    }
  }, [queryClient])
}
